import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await api.me();
      setUser(me);
    } catch (e) {
      if (e?.response?.status === 401) localStorage.removeItem("session_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth, skip initial /me — AuthCallback will set us up.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  // Phase 8: api.js dispatches this when any call 403s with account_suspended
  // (banned mid-session) — refreshing pulls banned:true and the App-level
  // gate swaps in the suspended view.
  useEffect(() => {
    const onSuspended = () => refresh();
    window.addEventListener("civic:suspended", onSuspended);
    return () => window.removeEventListener("civic:suspended", onSuspended);
  }, [refresh]);

  const logout = async () => {
    try { await api.logout(); } catch {}
    localStorage.removeItem("session_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
